var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('contact-breadcrumb',{attrs:{"contact":_vm.contact}}),(_vm.error)?_c('app-error',{attrs:{"error":_vm.error}}):_vm._e(),(!_vm.contact)?_c('app-loader',{attrs:{"large":""}}):_c('contact-editor',{attrs:{"readonly":true},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }